import { Component, OnInit } from '@angular/core';
import { companyInfo } from 'src/common';
import { DomSanitizer, SafeUrl} from '@angular/platform-browser'


@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.scss']
})
export class MapComponent implements OnInit {

  constructor(private sanitizer: DomSanitizer) { 

    let url="https://maps.google.com/maps?q="+ companyInfo.address.city+","+ companyInfo.address.street+"&t=&z=13&ie=UTF8&iwloc=&output=embed"

    this.trustedUrl = sanitizer.bypassSecurityTrustResourceUrl(url);
  }

  public showMap=false;

  ngOnInit(): void {

  }

  public trustedUrl:SafeUrl;
  public companyInfo=companyInfo;

}
